module.exports = __webpack_public_path__ + "img/collection-weddingRingsFacetes.db22e41.jpg";